import { arraysEqual } from 'src/replicant/utils/array';
import type { Component, Entity2D } from '../../odie';

import { BlockId, CountBlockOptionDef, FireboxBlockProps } from '../defs/block';
import { FireboxBlockView } from '../views/blocks/FireboxBlockView';

// types
//-----------------------------------------------------------------------------
export type FireboxBlockComponentOptions = {
  props: FireboxBlockProps;
  option?: number;
};

/*
    firebox block component
*/
export class FireboxBlockComponent implements Component {
  // constants
  //-------------------------------------------------------------------------
  public static readonly NAME = 'blockFirebox';

  // fields
  //-------------------------------------------------------------------------
  // injected
  public entity!: Entity2D;
  // scene
  public view!: FireboxBlockView;

  // properties
  //-------------------------------------------------------------------------
  private props!: FireboxBlockProps;
  // count
  public get count(): number {
    return this.view.count;
  }

  public set count(value: number) {
    this.view.count = value;
  }

  // spawn blocks
  public get spawnBlocks(): BlockId[] {
    return this._spawnBlocks;
  }

  private _spawnBlocks: BlockId[] = [];

  // impl
  //-------------------------------------------------------------------------
  public init(options: FireboxBlockComponentOptions): void {
    // get option def
    const optionDef = options.props.options?.[
      options.option || 0
    ] as CountBlockOptionDef;

    this.props = options.props;

    // create firebox block view
    this.view = new FireboxBlockView(options.props);

    // set initial count
    this.count = optionDef.count;
    this._spawnBlocks = optionDef.spawnBlocks;

    // Set the getGameplayState retrieval function
    this.entity.c.block.getGameplayState = () => this.getGameplayState();
  }

  public getGameplayState(): number {
    const options = this.props.options as CountBlockOptionDef[];
    return options.findIndex((opt) => {
      return (
        opt.count === this.view.count &&
        arraysEqual(opt.spawnBlocks, this._spawnBlocks)
      );
    });
  }
}
